var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zong"},[_c('div',{staticClass:"echart_container",attrs:{"id":_vm.groupId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }